import {
  MESSAGE_MEDIUMS_WITH_EMBEDDED,
  MessageMedium,
  MESSAGE_MEDIUM_WHATS_APP,
} from 'constants/messageMediums';
import { SendEmail, SendInApp, SendPush, SendSMS, SendWebPush } from 'ui/icons';
import { MediumEnum } from 'modules/iterableGoals/types';

/**
  Given a string identifier of the message medium, find the associated message medium object
  */
export const getMediumByKey = (key: string) => {
  const allMediums = { ...MESSAGE_MEDIUMS_WITH_EMBEDDED, ...MESSAGE_MEDIUM_WHATS_APP };
  // Should be safe to use embedded since this is a key lookup rather than a iteration
  return Object.values(allMediums).find(
    (msgMed) => msgMed.dbKey.toUpperCase() === key?.toUpperCase(),
  );
};

/**
  Given a string identifier of the message medium, find the associated label
 */
export const getLabelByMedium = (medium: string) => getMediumByKey(medium)?.label || medium;

/**
 * getMediumIcon
 * Takes a medium enum and returns an icon
 * @param medium
 * @returns JSX.Element
 */
export const getMediumIcon = (medium: MediumEnum | MessageMedium) =>
  ({
    [MediumEnum.EMAIL]: SendEmail,
    [MediumEnum.PUSH]: SendPush,
    [MediumEnum.SMS]: SendSMS,
    [MediumEnum.IN_APP]: SendInApp,
    [MessageMedium.InApp]: SendInApp,
    [MediumEnum.WEB_PUSH]: SendWebPush,
    [MessageMedium.WebPush]: SendWebPush,
  })[medium];
